import { advanceAuthGeneration, readAuthGeneration, siteKey } from './auth-flow';
import { createAuthMutationCoordinator, isAuthMutationSupported } from './auth-mutation-lock';
import { getPortalContext } from './portal-context';

let coordinator = null;
let coordinatorKey = null;

function browserStorage() {
	try {
		return window.localStorage;
	} catch (error) {
		return null;
	}
}

function contextKey(context) {
	return siteKey(context);
}

function authMutationSupported() {
	const context = getPortalContext();
	if (!context.enabled) return true;
	return isAuthMutationSupported(
		contextKey(context),
		context.busy_ttl_seconds * 1000,
	);
}

function getAuthMutationCoordinator() {
	const context = getPortalContext();
	if (!context.enabled) {
		return createAuthMutationCoordinator({
			enabled: false,
			contextKey: 'legacy',
			busyTtlMs: 60000,
			getAuthGeneration: () => 'legacy',
		});
	}

	const key = contextKey(context);
	if (coordinator && coordinatorKey === key) return coordinator;

	const storage = browserStorage();
	coordinator = createAuthMutationCoordinator({
		enabled: true,
		contextKey: key,
		busyTtlMs: context.busy_ttl_seconds * 1000,
		getAuthGeneration: () => storage ? readAuthGeneration(context, storage) : 'unavailable',
	});
	coordinatorKey = key;
	return coordinator;
}

function markAuthenticationChanged() {
	const context = getPortalContext();
	const storage = browserStorage();
	if (context.enabled && storage) {
		advanceAuthGeneration(context, storage);
	}
}

export {
	authMutationSupported,
	getAuthMutationCoordinator,
	markAuthenticationChanged,
};
